export default {
  colors: {
    body: '#edf2f7',
    primary: '#49b6d5',
    primaryLight: '#edf2f7',
    text: '#333',
    error: 'red',
    input: '#4a5568',
    searchBar: '#2b2b2b',
  },
  palette: {
    base: '#49b6d5',
  },
  buttons: {
    primary: {
      backgroundColor: '#49b6d5',
      textColor: '#ffffff',
    },
  },
};
